import nameBrand from './named/brand';
import nameEnv from './named/env';

import { dataTypes, validateDataType } from './constants';
import allFieldsDefinition, {
  typedFields,
  accessibility,
  editableFields,
  PACKAGE_TIERS,
} from './definition';
import * as helpers from './helpers';
import * as features from './features';
import * as utils from './utils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dataTypes: dataTypes,
  validateDataType: validateDataType,
  features: features,
  helpers: helpers,
  fields: {
    utils,
    all: allFieldsDefinition,
    typed: typedFields,
    accessibility: accessibility,
    editable: editableFields,
    packageTiers: PACKAGE_TIERS,
    named: {
      env: nameEnv,
      brand: nameBrand,
    },
  },
};
